import Dexie from 'dexie';

export const db = new Dexie('myDb3');
db.version(1).stores({
    AllShopifyProducts: '++id, Id, varinatId, productImage, productId, productTitle, productVendor, productStatus, inventoryItemId, variantTitle, variantPrice, variantSku, inventoryQuantity, inventoryTrackable, barcode, lastSynced',
});